import axios from "@/plugins/axios"
const token = localStorage.getItem("token");

export default {
    async getAllAutoJobCards(){
        let jobCards = [];
        const response = await axios.getData("/auth/get-All-service-cards", token);
        if (response?.status === "success") {
            jobCards = response.services;
        }
        return jobCards;
    },

    async getAutoServiceByInvoice(invoiceNumber){
        let jobCard = null;
        const response = await axios.postDataWithToken("/auth/get-auto-service-by-invoice",{invoiceNumber},token);
        if (response?.status === "success") {
            jobCard = response.autoJobCard;
        }
        return jobCard;
        
    }
}